/* eslint-disable array-callback-return */
// @ts-nocheck
import React from "react";
import { arrow_icon, delete_icon } from "../../assets/img";
import Select from "react-select";

const HousePolicyCondition = ({
  edit,
  type,
  optionsList,
  customStyles,
  handlePolicyConditionChange,
  errors,
  formData,
}) => {
  const filterOptions = (options, selectedList) => {
    let filtered = options?.filter((item) => {
      let finded = selectedList?.find((s) => s.value === item?.value);
      if (!finded) return true;
    });
    return filtered;
  };
  return (
    <>
      <div className="col-md-5">
        <div className="d-flex ac-jb mb-3">
          <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
            House Policy <span style={{ color: "red" }}>*</span>{" "}
          </p>
        </div>
        <div>
          <Select
            options={filterOptions(
              optionsList?.policies,
              formData?.housePolicy,
            )}
            isDisabled={!edit}
            placeholder="Select House Policy"
            name="housePolicy"
            value={null}
            onChange={(e) => {
              handlePolicyConditionChange("policy", e, "add");
            }}
            styles={customStyles}
          />
          {errors.housePolicy && formData?.housePolicy?.length === 0 && (
            <p className="err">{errors.housePolicy}</p>
          )}
        </div>

        <div>
          {formData?.housePolicy?.length > 0 && (
            <ul>
              {formData?.housePolicy?.map((name, index) => {
                return (
                  <li className="d-flex as-js gap-3 my-3" key={index}>
                    <img src={arrow_icon} className="back-arrow" alt="" />
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 col-md-10">
                      {name?.label}
                    </p>
                    {edit && (
                      <img
                        alt=""
                        src={delete_icon}
                        className="edit-btn"
                        onClick={() => {
                          handlePolicyConditionChange("policy", name, "delete");
                        }}
                      />
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
      <div className="col-md-5 ">
        <div className="d-flex ac-jb mb-3">
          <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
            Terms & Condition <span style={{ color: "red" }}>*</span>
          </p>
        </div>
        <div>
          <Select
            options={filterOptions(
              optionsList?.conditions,
              formData?.termsAndCondition,
            )}
            name="termsAndCondition"
            placeholder="Select Terms & Conditions"
            value={null}
            onChange={(e) => {
              handlePolicyConditionChange("terms", e, "add");
            }}
            styles={customStyles}
            isDisabled={edit ? false : true}
          />
          {errors.termsAndCondition &&
            formData?.termsAndCondition?.length === 0 && (
              <p className="err">{errors.termsAndCondition}</p>
            )}
        </div>
        <div>
          {formData?.termsAndCondition?.length > 0 && (
            <ul>
              {formData?.termsAndCondition?.map((name, index) => {
                return (
                  <li className="d-flex as-js gap-3 my-3" key={index}>
                    <img src={arrow_icon} className="back-arrow" alt="" />
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  col-md-10">
                      {name?.label}
                    </p>
                    {/* {edit && ( */}
                    {edit && (
                      <img
                        alt=""
                        src={delete_icon}
                        className="edit-btn"
                        onClick={() => {
                          handlePolicyConditionChange("terms", name, "delete");
                        }}
                      />
                    )}
                    {/* )} */}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};
export default HousePolicyCondition;
